import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';

/**
 * Guard pour les pages accessibles uniquement aux utilisateurs non authentifiés (ex: page de login).
 * Redirige les utilisateurs déjà connectés vers la page d'accueil.
 */
export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // Si l'utilisateur est authentifié, rediriger vers /home
  if (auth.isAuthenticated()) {
    router.navigate(['/home']);
    return false;
  }

  // Sinon, autoriser l'accès à la page de login
  return true;
};
